import { useLazyQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./YouMayAlsoLike.gql";
import { useEffect, useMemo } from "react";

export const useYouMayAlsoLike = (props) => {
  const { cartItems } = props;
  const { getYouMayAlsoLikeQuery } = DEFAULT_OPERATIONS;

  const cartItemsSku = useMemo(
    () =>
      cartItems.map((item) => {
        if (
          item.__typename === "ConfigurableCartItem" &&
          item.configured_variant
        ) {
          return item.configured_variant.sku;
        }
        return item.product.sku;
      }),
    [cartItems]
  );

  const [fetchYouMayAlsoLike, { called, data, loading }] = useLazyQuery(
    getYouMayAlsoLikeQuery,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
    }
  );

  useEffect(() => {
    fetchYouMayAlsoLike({
      variables: { skus: cartItemsSku },
    });
  }, [cartItemsSku]);

  const youMayALsoLikeProducts = useMemo(() => {
    let productData = [];
    if (data && data.products && data.products.items.length) {
      productData = data.products.items.flatMap(
        (item) => item.crosssell_products
      );
    }

    const seenIds = new Set();

    const crossSellProducts = productData.filter((item) => {
      if (seenIds.has(item.id)) {
        return false;
      }
      seenIds.add(item.id);
      return true;
    });

    return crossSellProducts;
  }, [data]);

  return { called, loading, youMayALsoLikeProducts };
};
